import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../data/data.service';
import { ModalBaseComponent } from './modal-base.component';
import { OrganizationDetail } from '../data/organization-detail';

@Component({
  selector: 'app-add-or-edit-org-modal',
  templateUrl: './add-or-edit-org-modal.component.html',
  styleUrls: ['./add-or-edit-org-modal.component.css']
})

export class AddOrEditOrgModalComponent extends ModalBaseComponent<OrganizationDetail> implements OnInit {

  constructor(modalService: NgbModal, dataService: DataService) { super(modalService, dataService); }

  @Input() parentOrganizationID: number;

  ngOnInit() {
    this.initializeNewData();
  }

  initializeNewData() {
    this.data = {
      ID: 0,
      Description: '',
      LoginCode: '',
      TypeCode: 'ADM',
      TypeDescription: '',
      ParentOrganizationID: this.parentOrganizationID,
      Administrators: []
    };
  }

  saveNew() {
    this.isWaiting = true;
    this.dataService.createOrganization(this.data).subscribe(o => this.saveComplete(o));
  }

  saveEdit() {
    this.isWaiting = true;
    this.dataService.updateOrganization(this.data).subscribe(o => this.saveComplete(o));
  }

  isInputValid(): boolean {
    return this.data.Description && this.data.Description.length > 0;
  }

  openForEdit(toEdit: OrganizationDetail) {
    this.modalHeader = "Edit Organization";
    super.openForEdit(toEdit);
  }

  openForNew() {
    this.modalHeader = "Add Sub-Organization";
    super.openForNew();
  }
}
